import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { useSessionDataEpoch } from '@/lib/sessionData';
import type { RentalPropertyInfo } from '@shared/types';

export function useRentalInfo() {
  const [info, setInfo] = useState<RentalPropertyInfo[]>([]);
  const [homeAddress, setHomeAddress] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const sessionEpoch = useSessionDataEpoch();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .get<{ info: RentalPropertyInfo[]; homeAddress?: string | null }>('/rental/info')
      .then((res) => {
        if (cancelled) return;
        setInfo(res.info ?? []);
        setHomeAddress(res.homeAddress ?? null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [sessionEpoch]);

  return { info, homeAddress, loading };
}
